"use strict";

var _slicedToArray = require("/Users/ronaldzwets/repos/aisukurimu/cardano-nft/cardano-nft-essentials/frontend/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _toConsumableArray = require("/Users/ronaldzwets/repos/aisukurimu/cardano-nft/cardano-nft-essentials/frontend/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _defineProperty = require("/Users/ronaldzwets/repos/aisukurimu/cardano-nft/cardano-nft-essentials/frontend/node_modules/@babel/runtime/helpers/defineProperty.js");

var _regeneratorRuntime = require("/Users/ronaldzwets/repos/aisukurimu/cardano-nft/cardano-nft-essentials/frontend/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/Users/ronaldzwets/repos/aisukurimu/cardano-nft/cardano-nft-essentials/frontend/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WalletType = exports.WalletApi = void 0;

var types_1 = require("../src/types");

Object.defineProperty(exports, "WalletType", {
  enumerable: true,
  get: function get() {
    return types_1.WalletType;
  }
});
var ERROR = {
  FAILED_PROTOCOL_PARAMETER: 'NO PROTOCOL PARAMS PASSED',
  TX_TOO_BIG: 'Transaction too big'
};

var typeOfwallet = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(type, api) {
    var _wallet;

    var wallet;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            wallet = (_wallet = {}, _defineProperty(_wallet, types_1.WalletType.NAMI, _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return api.nami.enable();

                    case 2:
                      return _context.abrupt("return", _context.sent);

                    case 3:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }))), _defineProperty(_wallet, types_1.WalletType.CCVAULT, _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
              return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.next = 2;
                      return api.ccvault.enable();

                    case 2:
                      return _context2.abrupt("return", _context2.sent);

                    case 3:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2);
            }))), _defineProperty(_wallet, types_1.WalletType.FLINT, _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
              return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      _context3.next = 2;
                      return api.flint.enable();

                    case 2:
                      return _context3.abrupt("return", _context3.sent);

                    case 3:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _callee3);
            }))), _wallet);
            return _context4.abrupt("return", wallet[type]());

          case 2:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function typeOfwallet(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var isTypeOfwalletEnabled = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(type, api) {
    var _wallet2;

    var wallet;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            wallet = (_wallet2 = {}, _defineProperty(_wallet2, types_1.WalletType.NAMI, _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
              var _api$nami;

              return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                  switch (_context5.prev = _context5.next) {
                    case 0:
                      _context5.next = 2;
                      return (_api$nami = api.nami) === null || _api$nami === void 0 ? void 0 : _api$nami.isEnabled();

                    case 2:
                      return _context5.abrupt("return", _context5.sent);

                    case 3:
                    case "end":
                      return _context5.stop();
                  }
                }
              }, _callee5);
            }))), _defineProperty(_wallet2, types_1.WalletType.CCVAULT, _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
              var _api$ccvault;

              return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                while (1) {
                  switch (_context6.prev = _context6.next) {
                    case 0:
                      _context6.next = 2;
                      return (_api$ccvault = api.ccvault) === null || _api$ccvault === void 0 ? void 0 : _api$ccvault.isEnabled();

                    case 2:
                      return _context6.abrupt("return", _context6.sent);

                    case 3:
                    case "end":
                      return _context6.stop();
                  }
                }
              }, _callee6);
            }))), _defineProperty(_wallet2, types_1.WalletType.FLINT, _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
              var _api$flint;

              return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                while (1) {
                  switch (_context7.prev = _context7.next) {
                    case 0:
                      _context7.next = 2;
                      return (_api$flint = api.flint) === null || _api$flint === void 0 ? void 0 : _api$flint.isEnabled();

                    case 2:
                      return _context7.abrupt("return", _context7.sent);

                    case 3:
                    case "end":
                      return _context7.stop();
                  }
                }
              }, _callee7);
            }))), _wallet2);
            return _context8.abrupt("return", wallet[type]());

          case 2:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function isTypeOfwalletEnabled(_x3, _x4) {
    return _ref5.apply(this, arguments);
  };
}();

function WalletApi(_x5, _x6, _x7, _x8) {
  return _WalletApi.apply(this, arguments);
}

function _WalletApi() {
  _WalletApi = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(walletObject, protocolParameterObject, type, serializationLib) {
    var serialize, Buffer, protocolParameter, api, CoinSelection, enable, isEnabled, getApiVersion, getApiName, getAddress, getAddressHex, getNetworkId, getUtxos, getAssets, getUtxosHex, send, sendMultiple, _sendMultiple, signData, _signData, AsciiToBuffer, HexToBuffer, AsciiToHex, HexToAscii, BufferToAscii, BufferToHex, makeMultiAsset, _utxoToAssets, _txBuilder, _signSubmitTx, _signSubmitTx2;

    return _regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            _signSubmitTx2 = function _signSubmitTx4() {
              _signSubmitTx2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(transactionRaw) {
                var transaction, witneses, signedTx, txhash;
                return _regeneratorRuntime.wrap(function _callee20$(_context20) {
                  while (1) {
                    switch (_context20.prev = _context20.next) {
                      case 0:
                        transaction = serialize.Transaction.from_bytes(transactionRaw);
                        _context20.next = 3;
                        return api.signTx(Buffer.from(transaction.to_bytes()).toString('hex'));

                      case 3:
                        witneses = _context20.sent;
                        signedTx = serialize.Transaction.new(transaction.body(), serialize.TransactionWitnessSet.from_bytes(Buffer.from(witneses, 'hex')), transaction.auxiliary_data());
                        _context20.next = 7;
                        return api.submitTx(Buffer.from(signedTx.to_bytes()).toString('hex'));

                      case 7:
                        txhash = _context20.sent;
                        return _context20.abrupt("return", txhash);

                      case 9:
                      case "end":
                        return _context20.stop();
                    }
                  }
                }, _callee20);
              }));
              return _signSubmitTx2.apply(this, arguments);
            };

            _signSubmitTx = function _signSubmitTx3(_x12) {
              return _signSubmitTx2.apply(this, arguments);
            };

            _txBuilder = function _txBuilder2(_ref20) {
              var PaymentAddress = _ref20.PaymentAddress,
                  Utxos = _ref20.Utxos,
                  Outputs = _ref20.Outputs,
                  ProtocolParameter = _ref20.ProtocolParameter,
                  _ref20$Metadata = _ref20.Metadata,
                  Metadata = _ref20$Metadata === void 0 ? null : _ref20$Metadata,
                  _ref20$MetadataLabel = _ref20.MetadataLabel,
                  MetadataLabel = _ref20$MetadataLabel === void 0 ? '721' : _ref20$MetadataLabel,
                  _ref20$Delegation = _ref20.Delegation,
                  Delegation = _ref20$Delegation === void 0 ? null : _ref20$Delegation;
              var MULTIASSET_SIZE = 5000;
              var VALUE_SIZE = 5000;
              var totalAssets = 0;
              CoinSelection.setLoader(serialize);
              CoinSelection.setProtocolParameters(ProtocolParameter.minUtxo.toString(), ProtocolParameter.linearFee.minFeeA.toString(), ProtocolParameter.linearFee.minFeeB.toString(), ProtocolParameter.maxTxSize.toString());
              var selection = CoinSelection.randomImprove(Utxos, Outputs, 20 + totalAssets //ProtocolParameter.minUtxo.to_str()
              );
              var inputs = selection.input;
              var txBuilder = serialize.TransactionBuilder.new(serialize.LinearFee.new(serialize.BigNum.from_str(ProtocolParameter.linearFee.minFeeA), serialize.BigNum.from_str(ProtocolParameter.linearFee.minFeeB)), serialize.BigNum.from_str(ProtocolParameter.minUtxo.toString()), serialize.BigNum.from_str(ProtocolParameter.poolDeposit.toString()), serialize.BigNum.from_str(ProtocolParameter.keyDeposit.toString()), MULTIASSET_SIZE, MULTIASSET_SIZE);

              for (var i = 0; i < inputs.length; i++) {
                var utxo = inputs[i];
                txBuilder.add_input(utxo.output().address(), utxo.input(), utxo.output().amount());
              }

              if (Delegation) {
                var certificates = serialize.Certificates.new();

                if (!Delegation.delegation.active) {
                  certificates.add(serialize.Certificate.new_stake_registration(serialize.StakeRegistration.new(serialize.StakeCredential.from_keyhash(serialize.Ed25519KeyHash.from_bytes(Buffer.from(Delegation.stakeKeyHash, 'hex'))))));
                }

                var poolKeyHash = Delegation.poolHex;
                certificates.add(serialize.Certificate.new_stake_delegation(serialize.StakeDelegation.new(serialize.StakeCredential.from_keyhash(serialize.Ed25519KeyHash.from_bytes(Buffer.from(Delegation.stakeKeyHash, 'hex'))), serialize.Ed25519KeyHash.from_bytes(Buffer.from(poolKeyHash, 'hex')))));
                txBuilder.set_certs(certificates);
              }

              var AUXILIARY_DATA;

              if (Metadata) {
                var METADATA = serialize.GeneralTransactionMetadata.new();
                METADATA.insert(serialize.BigNum.from_str(MetadataLabel), serialize.encode_json_str_to_metadatum(JSON.stringify(Metadata), 0));
                AUXILIARY_DATA = serialize.AuxiliaryData.new();
                AUXILIARY_DATA.set_metadata(METADATA); //const auxiliaryDataHash = serialize.hash_auxiliary_data(AUXILIARY_DATA)

                txBuilder.set_auxiliary_data(AUXILIARY_DATA);
              }

              for (var _i2 = 0; _i2 < Outputs.len(); _i2++) {
                txBuilder.add_output(Outputs.get(_i2));
              }

              var change = selection.change;
              var changeMultiAssets = change.multiasset(); // check if change value is too big for single output

              if (changeMultiAssets && change.to_bytes().length * 2 > VALUE_SIZE) {
                var partialChange = serialize.Value.new(serialize.BigNum.from_str('0'));
                var partialMultiAssets = serialize.MultiAsset.new();
                var policies = changeMultiAssets.keys();

                var makeSplit = function makeSplit() {
                  for (var j = 0; j < changeMultiAssets.len(); j++) {
                    var policy = policies.get(j);
                    var policyAssets = changeMultiAssets.get(policy);
                    var assetNames = policyAssets.keys();
                    var assets = serialize.Assets.new();

                    for (var k = 0; k < assetNames.len(); k++) {
                      var policyAsset = assetNames.get(k);
                      var quantity = policyAssets.get(policyAsset);
                      assets.insert(policyAsset, quantity); //check size

                      var checkMultiAssets = serialize.MultiAsset.from_bytes(partialMultiAssets.to_bytes());
                      checkMultiAssets.insert(policy, assets);
                      var checkValue = serialize.Value.new(serialize.BigNum.from_str('0'));
                      checkValue.set_multiasset(checkMultiAssets);

                      if (checkValue.to_bytes().length * 2 >= VALUE_SIZE) {
                        partialMultiAssets.insert(policy, assets);
                        return;
                      }
                    }

                    partialMultiAssets.insert(policy, assets);
                  }
                };

                makeSplit();
                partialChange.set_multiasset(partialMultiAssets);
                var minAda = serialize.min_ada_required(partialChange, serialize.BigNum.from_str(ProtocolParameter.minUtxo));
                partialChange.set_coin(minAda);
                txBuilder.add_output(serialize.TransactionOutput.new(serialize.Address.from_bech32(PaymentAddress), partialChange));
              }

              txBuilder.add_change_if_needed(serialize.Address.from_bech32(PaymentAddress));
              var transaction = serialize.Transaction.new(txBuilder.build(), serialize.TransactionWitnessSet.new(), AUXILIARY_DATA);
              var size = transaction.to_bytes().length * 2;
              if (size > ProtocolParameter.maxTxSize) throw ERROR.TX_TOO_BIG;
              return transaction.to_bytes();
            };

            _utxoToAssets = function _utxoToAssets2(utxo) {
              var value = utxo.output().amount();
              var assets = [];
              assets.push({
                unit: 'lovelace',
                quantity: value.coin().to_str()
              });

              if (value.multiasset()) {
                var multiAssets = value.multiasset().keys();

                for (var j = 0; j < multiAssets.len(); j++) {
                  var policy = multiAssets.get(j);
                  var policyAssets = value.multiasset().get(policy);
                  var assetNames = policyAssets.keys();

                  for (var k = 0; k < assetNames.len(); k++) {
                    var policyAsset = assetNames.get(k);
                    var quantity = policyAssets.get(policyAsset);
                    var asset = Buffer.from(policy.to_bytes()).toString('hex') + '.' + Buffer.from(policyAsset.name()).toString('ascii');
                    assets.push({
                      unit: asset,
                      quantity: quantity.to_str()
                    });
                  }
                }
              }

              return assets;
            };

            makeMultiAsset = function _makeMultiAsset(assets) {
              var AssetsMap = {};

              var _iterator2 = _createForOfIteratorHelper(assets),
                  _step2;

              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  var _asset = _step2.value;

                  var _asset$unit$split = _asset.unit.split('.'),
                      _asset$unit$split2 = _slicedToArray(_asset$unit$split, 2),
                      _policy = _asset$unit$split2[0],
                      assetName = _asset$unit$split2[1];

                  var quantity = _asset.quantity;

                  if (!Array.isArray(AssetsMap[_policy])) {
                    AssetsMap[_policy] = [];
                  }

                  AssetsMap[_policy].push({
                    unit: Buffer.from(assetName, 'ascii').toString('hex'),
                    quantity: quantity
                  });
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }

              var multiAsset = serialize.MultiAsset.new();

              for (var policy in AssetsMap) {
                var ScriptHash = serialize.ScriptHash.from_bytes(Buffer.from(policy, 'hex'));
                var Assets = serialize.Assets.new();
                var _assets = AssetsMap[policy];

                var _iterator3 = _createForOfIteratorHelper(_assets),
                    _step3;

                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    var asset = _step3.value;
                    var AssetName = serialize.AssetName.new(Buffer.from(asset.unit, 'hex'));
                    var BigNum = serialize.BigNum.from_str(asset.quantity);
                    Assets.insert(AssetName, BigNum);
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }

                multiAsset.insert(ScriptHash, Assets);
              }

              return multiAsset;
            };

            BufferToHex = function _BufferToHex(buffer) {
              return buffer.toString('hex');
            };

            BufferToAscii = function _BufferToAscii(buffer) {
              return buffer.toString('ascii');
            };

            HexToAscii = function _HexToAscii(string) {
              return HexToBuffer(string).toString('ascii');
            };

            AsciiToHex = function _AsciiToHex(string) {
              return AsciiToBuffer(string).toString('hex');
            };

            HexToBuffer = function _HexToBuffer(string) {
              return Buffer.from(string, 'hex');
            };

            AsciiToBuffer = function _AsciiToBuffer(string) {
              return Buffer.from(string, 'ascii');
            };

            _signData = function _signData3() {
              _signData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(string) {
                var address, coseSign1Hex;
                return _regeneratorRuntime.wrap(function _callee19$(_context19) {
                  while (1) {
                    switch (_context19.prev = _context19.next) {
                      case 0:
                        _context19.next = 2;
                        return getAddressHex();

                      case 2:
                        address = _context19.sent;
                        _context19.next = 5;
                        return api.signData(address, Buffer.from(string, 'ascii').toString('hex'));

                      case 5:
                        coseSign1Hex = _context19.sent;
                        return _context19.abrupt("return", coseSign1Hex);

                      case 7:
                      case "end":
                        return _context19.stop();
                    }
                  }
                }, _callee19);
              }));
              return _signData.apply(this, arguments);
            };

            signData = function _signData2(_x11) {
              return _signData.apply(this, arguments);
            };

            _sendMultiple = function _sendMultiple3() {
              _sendMultiple = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(_ref19) {
                var _ref19$recipients, recipients, _ref19$metadata, metadata, _ref19$metadataLabel, metadataLabel, PaymentAddress, utxos, outputs, _iterator4, _step4, recipient, lovelace, ReceiveAddress, multiAsset, outputValue, minAda, RawTransaction;

                return _regeneratorRuntime.wrap(function _callee18$(_context18) {
                  while (1) {
                    switch (_context18.prev = _context18.next) {
                      case 0:
                        _ref19$recipients = _ref19.recipients, recipients = _ref19$recipients === void 0 ? [] : _ref19$recipients, _ref19$metadata = _ref19.metadata, metadata = _ref19$metadata === void 0 ? null : _ref19$metadata, _ref19$metadataLabel = _ref19.metadataLabel, metadataLabel = _ref19$metadataLabel === void 0 ? '721' : _ref19$metadataLabel;
                        _context18.next = 3;
                        return getAddress();

                      case 3:
                        PaymentAddress = _context18.sent;
                        _context18.next = 6;
                        return getUtxosHex();

                      case 6:
                        utxos = _context18.sent.map(function (u) {
                          return serialize.TransactionUnspentOutput.from_bytes(Buffer.from(u, 'hex'));
                        });
                        outputs = serialize.TransactionOutputs.new();
                        _iterator4 = _createForOfIteratorHelper(recipients);

                        try {
                          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                            recipient = _step4.value;
                            lovelace = Math.floor((recipient.amount || 0) * 1000000).toString();
                            ReceiveAddress = recipient.address;
                            multiAsset = makeMultiAsset(recipient.assets || []);
                            outputValue = serialize.Value.new(serialize.BigNum.from_str(lovelace));
                            if ((recipient.assets || []).length > 0) outputValue.set_multiasset(multiAsset);
                            minAda = serialize.min_ada_required(outputValue, serialize.BigNum.from_str(protocolParameter.minUtxo || '1000000'));
                            if (serialize.BigNum.from_str(lovelace).compare(minAda) < 0) outputValue.set_coin(minAda);
                            outputs.add(serialize.TransactionOutput.new(serialize.Address.from_bech32(ReceiveAddress), outputValue));
                          }
                        } catch (err) {
                          _iterator4.e(err);
                        } finally {
                          _iterator4.f();
                        }

                        RawTransaction = _txBuilder({
                          PaymentAddress: PaymentAddress,
                          Utxos: utxos,
                          Outputs: outputs,
                          ProtocolParameter: protocolParameter,
                          Metadata: metadata,
                          MetadataLabel: metadataLabel,
                          Delegation: null
                        });
                        _context18.next = 13;
                        return _signSubmitTx(RawTransaction);

                      case 13:
                        return _context18.abrupt("return", _context18.sent);

                      case 14:
                      case "end":
                        return _context18.stop();
                    }
                  }
                }, _callee18);
              }));
              return _sendMultiple.apply(this, arguments);
            };

            sendMultiple = function _sendMultiple2(_x10) {
              return _sendMultiple.apply(this, arguments);
            };

            _context21.t0 = serializationLib;

            if (_context21.t0) {
              _context21.next = 20;
              break;
            }

            _context21.next = 19;
            return Promise.resolve().then(function () {
              return __importStar(require('@emurgo/cardano-serialization-lib-asmjs'));
            });

          case 19:
            _context21.t0 = _context21.sent;

          case 20:
            serialize = _context21.t0;
            _context21.next = 23;
            return Promise.resolve().then(function () {
              return __importStar(require('buffer'));
            });

          case 23:
            Buffer = _context21.sent.Buffer;
            protocolParameter = protocolParameterObject;
            api = walletObject;
            _context21.next = 28;
            return Promise.resolve().then(function () {
              return __importStar(require('./coinSelection'));
            });

          case 28:
            CoinSelection = _context21.sent.default;

            enable = /*#__PURE__*/function () {
              var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
                return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                  while (1) {
                    switch (_context9.prev = _context9.next) {
                      case 0:
                        _context9.prev = 0;
                        _context9.next = 3;
                        return typeOfwallet(type, walletObject);

                      case 3:
                        api = _context9.sent;
                        _context9.next = 9;
                        break;

                      case 6:
                        _context9.prev = 6;
                        _context9.t0 = _context9["catch"](0);
                        throw _context9.t0;

                      case 9:
                      case "end":
                        return _context9.stop();
                    }
                  }
                }, _callee9, null, [[0, 6]]);
              }));

              return function enable() {
                return _ref9.apply(this, arguments);
              };
            }();

            isEnabled = /*#__PURE__*/function () {
              var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
                return _regeneratorRuntime.wrap(function _callee10$(_context10) {
                  while (1) {
                    switch (_context10.prev = _context10.next) {
                      case 0:
                        _context10.next = 2;
                        return isTypeOfwalletEnabled(type, walletObject);

                      case 2:
                        return _context10.abrupt("return", _context10.sent);

                      case 3:
                      case "end":
                        return _context10.stop();
                    }
                  }
                }, _callee10);
              }));

              return function isEnabled() {
                return _ref10.apply(this, arguments);
              };
            }();

            getApiVersion = function getApiVersion() {
              var _walletObject$type;

              return (_walletObject$type = walletObject[type]) === null || _walletObject$type === void 0 ? void 0 : _walletObject$type.apiVersion;
            };

            getApiName = function getApiName() {
              var _walletObject$type2;

              return (_walletObject$type2 = walletObject[type]) === null || _walletObject$type2 === void 0 ? void 0 : _walletObject$type2.name;
            };

            getAddress = /*#__PURE__*/function () {
              var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
                return _regeneratorRuntime.wrap(function _callee11$(_context11) {
                  while (1) {
                    switch (_context11.prev = _context11.next) {
                      case 0:
                        _context11.t0 = serialize.Address;
                        _context11.t1 = Buffer;
                        _context11.next = 4;
                        return getAddressHex();

                      case 4:
                        _context11.t2 = _context11.sent;
                        _context11.t3 = _context11.t1.from.call(_context11.t1, _context11.t2, 'hex');
                        return _context11.abrupt("return", _context11.t0.from_bytes.call(_context11.t0, _context11.t3).to_bech32());

                      case 7:
                      case "end":
                        return _context11.stop();
                    }
                  }
                }, _callee11);
              }));

              return function getAddress() {
                return _ref11.apply(this, arguments);
              };
            }();

            getAddressHex = /*#__PURE__*/function () {
              var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
                return _regeneratorRuntime.wrap(function _callee12$(_context12) {
                  while (1) {
                    switch (_context12.prev = _context12.next) {
                      case 0:
                        _context12.next = 2;
                        return api.getChangeAddress();

                      case 2:
                        return _context12.abrupt("return", _context12.sent);

                      case 3:
                      case "end":
                        return _context12.stop();
                    }
                  }
                }, _callee12);
              }));

              return function getAddressHex() {
                return _ref12.apply(this, arguments);
              };
            }();

            getNetworkId = /*#__PURE__*/function () {
              var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
                var id, network;
                return _regeneratorRuntime.wrap(function _callee13$(_context13) {
                  while (1) {
                    switch (_context13.prev = _context13.next) {
                      case 0:
                        _context13.next = 2;
                        return api.getNetworkId();

                      case 2:
                        id = _context13.sent;
                        network = id == 1 ? 'mainnet' : 'testnet';
                        return _context13.abrupt("return", {
                          id: id,
                          network: network
                        });

                      case 5:
                      case "end":
                        return _context13.stop();
                    }
                  }
                }, _callee13);
              }));

              return function getNetworkId() {
                return _ref13.apply(this, arguments);
              };
            }();

            getUtxos = /*#__PURE__*/function () {
              var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
                var Utxos, UTXOS, _iterator, _step, utxo, assets;

                return _regeneratorRuntime.wrap(function _callee14$(_context14) {
                  while (1) {
                    switch (_context14.prev = _context14.next) {
                      case 0:
                        _context14.next = 2;
                        return getUtxosHex();

                      case 2:
                        Utxos = _context14.sent.map(function (u) {
                          return serialize.TransactionUnspentOutput.from_bytes(Buffer.from(u, 'hex'));
                        });
                        UTXOS = [];
                        _iterator = _createForOfIteratorHelper(Utxos);

                        try {
                          for (_iterator.s(); !(_step = _iterator.n()).done;) {
                            utxo = _step.value;
                            assets = _utxoToAssets(utxo);
                            UTXOS.push({
                              txHash: Buffer.from(utxo.input().transaction_id().to_bytes(), 'hex').toString('hex'),
                              txId: utxo.input().index(),
                              amount: assets
                            });
                          }
                        } catch (err) {
                          _iterator.e(err);
                        } finally {
                          _iterator.f();
                        }

                        return _context14.abrupt("return", UTXOS);

                      case 7:
                      case "end":
                        return _context14.stop();
                    }
                  }
                }, _callee14);
              }));

              return function getUtxos() {
                return _ref14.apply(this, arguments);
              };
            }();

            getAssets = /*#__PURE__*/function () {
              var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
                var utxos, assetsRaw, assetsMap, _i, _assetsRaw, rawAsset, quantity;

                return _regeneratorRuntime.wrap(function _callee15$(_context15) {
                  while (1) {
                    switch (_context15.prev = _context15.next) {
                      case 0:
                        _context15.next = 2;
                        return getUtxos();

                      case 2:
                        utxos = _context15.sent;
                        assetsRaw = [];
                        utxos.forEach(function (u) {
                          assetsRaw.push.apply(assetsRaw, _toConsumableArray(u.amount.filter(function (a) {
                            return a.unit != 'lovelace';
                          })));
                        });
                        assetsMap = {};

                        for (_i = 0, _assetsRaw = assetsRaw; _i < _assetsRaw.length; _i++) {
                          rawAsset = _assetsRaw[_i];
                          quantity = parseInt(rawAsset.quantity);
                          if (!assetsMap[rawAsset.unit]) assetsMap[rawAsset.unit] = 0;
                          assetsMap[rawAsset.unit] += quantity;
                        }

                        return _context15.abrupt("return", Object.keys(assetsMap).map(function (asset) {
                          return {
                            unit: asset,
                            quantity: assetsMap[asset].toString()
                          };
                        }));

                      case 8:
                      case "end":
                        return _context15.stop();
                    }
                  }
                }, _callee15);
              }));

              return function getAssets() {
                return _ref15.apply(this, arguments);
              };
            }();

            getUtxosHex = /*#__PURE__*/function () {
              var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
                return _regeneratorRuntime.wrap(function _callee16$(_context16) {
                  while (1) {
                    switch (_context16.prev = _context16.next) {
                      case 0:
                        _context16.next = 2;
                        return api.getUtxos();

                      case 2:
                        return _context16.abrupt("return", _context16.sent);

                      case 3:
                      case "end":
                        return _context16.stop();
                    }
                  }
                }, _callee16);
              }));

              return function getUtxosHex() {
                return _ref16.apply(this, arguments);
              };
            }();

            send = /*#__PURE__*/function () {
              var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(_ref17) {
                var address, _ref17$amount, amount, _ref17$assets, assets, _ref17$metadata, metadata, _ref17$metadataLabel, metadataLabel, lovelace, multiAsset, outputValue, paymentAddress, receiveAddress, outputs, utxos, minAda, RawTransaction;

                return _regeneratorRuntime.wrap(function _callee17$(_context17) {
                  while (1) {
                    switch (_context17.prev = _context17.next) {
                      case 0:
                        address = _ref17.address, _ref17$amount = _ref17.amount, amount = _ref17$amount === void 0 ? 0 : _ref17$amount, _ref17$assets = _ref17.assets, assets = _ref17$assets === void 0 ? [] : _ref17$assets, _ref17$metadata = _ref17.metadata, metadata = _ref17$metadata === void 0 ? null : _ref17$metadata, _ref17$metadataLabel = _ref17.metadataLabel, metadataLabel = _ref17$metadataLabel === void 0 ? '721' : _ref17$metadataLabel;
                        lovelace = Math.floor(amount * 1000000).toString();
                        multiAsset = makeMultiAsset(assets);
                        outputValue = serialize.Value.new(serialize.BigNum.from_str(lovelace));
                        _context17.next = 6;
                        return getAddress();

                      case 6:
                        paymentAddress = _context17.sent;
                        receiveAddress = address;
                        outputs = serialize.TransactionOutputs.new();
                        _context17.next = 11;
                        return getUtxosHex();

                      case 11:
                        utxos = _context17.sent.map(function (u) {
                          return serialize.TransactionUnspentOutput.from_bytes(Buffer.from(u, 'hex'));
                        });

                        if (assets.length > 0) {
                          outputValue.set_multiasset(multiAsset);
                        }

                        minAda = serialize.min_ada_required(outputValue, serialize.BigNum.from_str(protocolParameter.minUtxo || '1000000'));

                        if (serialize.BigNum.from_str(lovelace).compare(minAda) < 0) {
                          outputValue.set_coin(minAda);
                        }

                        outputs.add(serialize.TransactionOutput.new(serialize.Address.from_bech32(receiveAddress), outputValue));
                        RawTransaction = _txBuilder({
                          PaymentAddress: paymentAddress,
                          Utxos: utxos,
                          Outputs: outputs,
                          ProtocolParameter: protocolParameter,
                          Metadata: metadata,
                          MetadataLabel: metadataLabel,
                          Delegation: null
                        });
                        _context17.next = 19;
                        return _signSubmitTx(RawTransaction);

                      case 19:
                        return _context17.abrupt("return", _context17.sent);

                      case 20:
                      case "end":
                        return _context17.stop();
                    }
                  }
                }, _callee17);
              }));

              return function send(_x9) {
                return _ref18.apply(this, arguments);
              };
            }();

            return _context21.abrupt("return", {
              isEnabled: isEnabled,
              enable: enable,
              getAddress: getAddress,
              getAddressHex: getAddressHex,
              getNetworkId: getNetworkId,
              getUtxos: getUtxos,
              getAssets: getAssets,
              getUtxosHex: getUtxosHex,
              getApiVersion: getApiVersion,
              getApiName: getApiName,
              send: send,
              sendMultiple: sendMultiple,
              auxiliary: {
                Buffer: Buffer,
                AsciiToBuffer: AsciiToBuffer,
                HexToBuffer: HexToBuffer,
                AsciiToHex: AsciiToHex,
                HexToAscii: HexToAscii,
                BufferToAscii: BufferToAscii,
                BufferToHex: BufferToHex
              }
            });

          case 41:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21);
  }));
  return _WalletApi.apply(this, arguments);
}

exports.WalletApi = WalletApi;